import "./button.scss"

const Button = (props) => {
  const resolvedTestId = props.testId || props.id || (props.label && props.label !== "New Button" ? `btn-${props.label.replace(/\s+/g, '-').toLowerCase()}` : undefined);
  return (
  <button
    onClick={props.onButtonClickHandler}
    type={props.type}
    className={["button", props.className].join(" ")}
    data-testid={resolvedTestId}
    id={props.id}
  >
    {props.label}
  </button>
  );
}
Button.defaultProps = {
  className: "",
  type: "button",
  label: "New Button",
  onButtonClickHandler: () => {},
  testId: undefined,
  id: undefined,
}
export default Button
